/**
 * @module ShowMoreOrLessDirective
 * @date 03/08/2017
 * @copyright 2017 Empower Retirement
 * @description
 *
 *      TODO
 *
 */

//-----------------------------------------------------------------------
// CONSTRUCTOR
//-----------------------------------------------------------------------

/**
 * The constructor's parameters are "injected" via AJS's IoC.
 *
 * @constructor
 */
var ShowMoreOrLessDirective = function (
    $compile,
    showMoreOrLessValidationFactory,
    wordBasedTruncationFactory,
    extendCharBasedTruncationFactory,
    $timeout
) {
    //-----------------------------------------------------------------------
    // PROTECTED METHODS
    //-----------------------------------------------------------------------

    /**
     * Determines if truncation should be applied based on the length of the text and
     * the threshold number.
     *
     * @returns {Boolean}
     */
    var directive = {
        restrict: "A",
        scope: {
            text: "=showMoreOrLess",
            disableScroll: "=disableScroll",
            charsThreshold: "@charsThreshold",
            wordsThreshold: "@wordsThreshold",
            customMoreLabel: "@customMoreLabel",
            customLessLabel: "@customLessLabel",
            elementId: "@elementId"
        },
        controller: [
            "$scope",
            "$element",
            "$attrs",
            function ($scope, $element, $attrs) {
                var offsetTop;
                var openclosepoint;

                $scope.handleKeydownToggleShow = function (event) {
                    if (!["Enter", "Tab", "Shift", " "].includes(event.key)) return;
                    var element = $element.find("span.ngTruncateToggleText").toArray();
                    event.key === " " && event.preventDefault();
                    if (["Enter", " "].includes(event.key)) {
                        $scope.toggleShow();
                        document.activeElement.innerText === "View more" &&
                            $scope.handleKeydownFocus(element[1]);
                        document.activeElement.innerText === "View less" &&
                            $scope.handleKeydownFocus(element[0]);
                    } else if (["Tab", "Shift"].includes(event.key)) {
                        $scope.removeFocusStyle(element[0]);
                        $scope.removeFocusStyle(element[1]);
                    }
                };

                $scope.handleKeydownFocus = function (element) {
                    setTimeout(() => {
                        element.style.border = "3px solid black";
                        element.style.outlineOffset = "-2px";
                        element.style.borderRadius = "4px";
                        element.focus();
                    }, 10);
                };

                $scope.removeFocusStyle = function (element) {
                    element.style.border = "none";
                    element.style.outlineOffset = "0px";
                    element.style.borderRadius = "0px";
                };

                $scope.toggleShow = function () {
                    $scope.open = !$scope.open;

                    //this will set and open/close class, so we can hide images accordinly
                    $element.removeClass("comboOpen");
                    $element.removeClass("comboClose");
                    var status = $scope.open ? "comboOpen" : "comboClose";
                    $element.addClass(status);

                    //This is only on Plan MESSAGEs, NO TTK
                    if (document.getElementById("messaging-slides")) {
                        /*THIS IS WORKING SENDING THE USER TO INIT LINE OF MESSAGE ALWAYS*/
                        //Keeping it temporary just in case they change their mind.

                        /*
                                var defect= document.getElementById("ID0").offsetTop - 1;
                                var elementPosition=document.getElementById($scope.elementId).offsetTop;
                                 
                                document.getElementById("messaging-slides").scrollTop = elementPosition-defect;
                                 //console.log("Go to:",elementPosition-defect);
                                 
                                */

                        /*THIS IS WORKING SENDING THE USER TO line they cliked to open the message  ALWAYS*/

                        if ($scope.open) {
                            ///do on open
                            openclosepoint = document.getElementById("messaging-slides").scrollTop;
                        }

                        $timeout(function () {
                            document.getElementById("messaging-slides").scrollTop = openclosepoint;
                        }, 0);
                    }

                    //This scroll to the top of the page
                    if (!$scope.disableScroll) {
                        if (!$scope.open) {
                            $scope.scrollToTop();
                        }
                    }
                };

                $scope.scrollToTop = function () {
                    // Easing ESLint as $document.{object} doesn't have the prop `scrollTop` and throws an error.
                    document.body.scrollTop = document.documentElement.scrollTop = 0; // eslint-disable-line
                };

                $scope.useToggling = $attrs.ngTtNoToggling === undefined;
            }
        ],
        link: function ($scope, $element, $attrs) {
            $scope.open = false;

            var CHARS_THRESHOLD = parseInt($scope.charsThreshold);
            var WORDS_THRESHOLD = parseInt($scope.wordsThreshold);

            showMoreOrLessValidationFactory.failIfWrongThresholdConfig(
                CHARS_THRESHOLD,
                WORDS_THRESHOLD
            );

            $scope.$watch("text", function () {
                // Remove the current DOM nodes from the directive's node...clear the table.
                $element.empty();

                if ($scope.text) {
                    var textToTruncate = $scope.text;
                    var truncationFactory = CHARS_THRESHOLD
                        ? extendCharBasedTruncationFactory
                        : wordBasedTruncationFactory;

                    var threshold = CHARS_THRESHOLD ? CHARS_THRESHOLD : WORDS_THRESHOLD;
                    var customMoreLabel = $scope.customMoreLabel;
                    var customLessLabel = $scope.customLessLabel;
                    var useToggling = $scope.useToggling;
                    var html = "";

                    if (
                        truncationFactory.truncationApplies(
                            truncationFactory.removeHrefText(textToTruncate),
                            threshold
                        )
                    ) {
                        html = truncationFactory.applyTruncation(
                            textToTruncate,
                            threshold,
                            customMoreLabel,
                            customLessLabel,
                            useToggling
                        );
                        var el = angular.element(html);
                        $compile(el)($scope);
                        $element.append(el);
                        $element.addClass("comboClose");
                    } else {
                        $element.append(textToTruncate);
                    }
                }

                //this will detect if it is only one image, so if it has some text, it is not an image only
                var innerText = $element[0].innerText;

                if (innerText.length > 1) {
                    $element.addClass("hasText");
                }
            });
        }
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    return directive;
};

ShowMoreOrLessDirective.$inject = [
    "$compile",
    "showMoreOrLessValidationFactory",
    "wordBasedTruncationFactory",
    "extendCharBasedTruncationFactory",
    "$timeout"
];
export default ShowMoreOrLessDirective;
